import axios from 'axios'
const proxyConfig = require('../config/config');

const API_CLIENT = axios.create({
    baseURL: `${proxyConfig.ip_proxy + ':' + proxyConfig.port_proxy + '/' + proxyConfig.subPath }`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: proxyConfig.requestTimeout
});

const API_CLIENT_CUSTOM = axios.create({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: proxyConfig.requestTimeout
});

export default {
    async getLocalization(module, customLocalization) {
        const GET_LOCALE_FROM_API = API_CLIENT.get(`/${proxyConfig.localization.getPath}`, {params: {module}});
        if (customLocalization){
            const GET_LOCALE_CUSTOM = API_CLIENT_CUSTOM.get(customLocalization);
            return await Promise.all([GET_LOCALE_FROM_API,GET_LOCALE_CUSTOM]);
        }
        else {
            return await GET_LOCALE_FROM_API;
        }
            
     
    }
}
